import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import AlertModalAction from './AlertModalAction'

interface AlertModalProps {
  open: boolean // Indicates if the modal is open
  onClose: () => void // Function to handle modal close
  title: string // Title of the modal
  description: string // Description of the modal
  actionButton: React.ReactNode // Content for the action buttons
}

const AlertModal: React.FC<AlertModalProps> = ({ open, onClose, title, description, actionButton }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{description}</DialogContentText>
      </DialogContent>
      <AlertModalAction>{actionButton}</AlertModalAction>
    </Dialog>
  )
}

export default AlertModal
